import React, { FC } from "react";

import MarketplaceSection from "sections/marketplacePage/MarketplaceSection";

import Layout from "components/Layout";

const MarketplaceEthereum: FC = () => {
  return (
    <Layout
      paddingTop={8}
      subHeader={{
        header: "Marketplace",
        description:
          "Did you miss the chance to catch the NFTs you really wanted? No worries. You can buy them second-hand on our Marketplace",
        background: `${process.env.NEXT_PUBLIC_CLOUDFRONT_URL}/pages/subheader/marketplace.jpg`,
        isBackgroundGradient: true,
      }}
    >
      <MarketplaceSection />
    </Layout>
  );
};

export default MarketplaceEthereum;
